import { format } from 'date-fns';
import { FC } from 'react';
import { ICalendarEvent } from '../../types';

interface IProps {
  calEvent: ICalendarEvent;
}

const EventTooltip: FC<IProps> = ({ calEvent }) => {
  return (
    <div className="event-calendar__tooltip">
      {calEvent.thumbnail && (
        <div
          className="event-calendar__tooltip-image"
          style={{ backgroundImage: `url(${calEvent.thumbnail})` }}
        ></div>
      )}
      <div className="event-calendar__tooltip-inner">
        <div className="event-calendar__tooltip-title">{calEvent.title}</div>
        <div className="event-calendar__tooltip-date">
          <div>{format(new Date(calEvent.date), 'MMMM d, y')}</div>
          {format(new Date(calEvent.date), 'hh:mm aa')}
        </div>
        {calEvent.buttons.event_learn_url && (
          <a
            target="_blank"
            rel="noreferrer"
            className="event-calendar__tooltip-link"
            href={calEvent.buttons.event_learn_url}
          >
            Learn more
          </a>
        )}
        {calEvent.buttons.event_report_url && (
          <a
            target="_blank"
            rel="noreferrer"
            className="event-calendar__tooltip-link"
            href={calEvent.buttons.event_report_url}
          >
            Report
          </a>
        )}
        {calEvent.buttons.event_site_url && (
          <a
            target="_blank"
            rel="noreferrer"
            className="event-calendar__tooltip-link"
            href={calEvent.buttons.event_site_url}
          >
            Visit website
          </a>
        )}
        {calEvent.buttons.event_video_url && (
          <a
            target="_blank"
            rel="noreferrer"
            className="event-calendar__tooltip-link"
            href={calEvent.buttons.event_video_url}
          >
            Video
          </a>
        )}
      </div>
    </div>
  );
};

export default EventTooltip;
